// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-k_gE","advertDetailHeaderLocation__value":"c-k_gF"};